import { useAtom } from 'jotai';
import { CSSProperties, useEffect, PropsWithChildren } from 'react';

import { WorkspaceSidebar } from '@/features/workspace-sidebar';

import { useDocumentId } from '@/hooks/use-document-id';
import { useElementResize } from '@flintmint/web-shared/hooks/use-element-resize';

import { toRem } from '@flintmint/web-shared/utils/ui';
import { emptyLayoutAtom } from '@/state';

import styles from './workspace.module.scss';

export const Workspace = (props: WorkspaceProps) => {
  const { children } = props;

  const [isEmptyLayout, setEmptyLayout] = useAtom(emptyLayoutAtom);

  const { id } = useDocumentId();

  const { ref, clientWidth } = useElementResize<HTMLDivElement>([isEmptyLayout]);

  useEffect(() => {
    setEmptyLayout(!id);
  }, [id]);

  return (
    <>
      {!isEmptyLayout && (
        <>
          <div
            key={id}
            ref={ref}
            className={styles.editorWorkspace}
            style={{ '--workspaceWidth': toRem(clientWidth) } as CSSProperties}
          >
            {children}
          </div>
          <WorkspaceSidebar />
        </>
      )}
    </>
  );
};

interface WorkspaceProps extends PropsWithChildren {}
